import { ArrowLeft, ArrowRight } from "lucide-react";

type InlineArrowProps = {
  /** Visual direction. Defaults to "right" (the common CTA case). */
  direction?: "right" | "left";
  /** Pixel size; defaults to 15 to sit comfortably with ~13-15px text. */
  size?: number;
  /** Extra classes — e.g. "transition group-hover:translate-x-0.5". */
  className?: string;
};

/**
 * InlineArrow — the single source of truth for directional arrow glyphs used as
 * UI affordances (CTA links/buttons, "maps-to" indicators, the module back nav).
 *
 * It inherits `currentColor` and is baseline-aligned so it drops into a line of
 * text where a `→`/`←` character used to be. Decorative only (`aria-hidden`);
 * the surrounding link/button already carries the accessible label.
 */
export function InlineArrow({
  direction = "right",
  size = 15,
  className = "",
}: InlineArrowProps) {
  const Icon = direction === "left" ? ArrowLeft : ArrowRight;
  return (
    <Icon
      size={size}
      strokeWidth={2}
      aria-hidden="true"
      className={`inline-block shrink-0 align-[-0.125em] ${className}`.trim()}
    />
  );
}
